import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import { getCallouts } from '../../clients/ecosystemClient';
export const fetchCallouts = createAsyncThunk('callouts/fetchAll', () => {
  return getCallouts();
});
const initialState = {
  list: [],
  requestState: RequestStates.UNINITIALIZED
};
export const calloutsSlice = createSlice({
  name: 'callouts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCallouts.pending, state => {
      state.requestState = RequestStates.PENDING;
    }).addCase(fetchCallouts.fulfilled, (state, action) => {
      state.requestState = RequestStates.SUCCEEDED;
      state.list = action.payload;
    }).addCase(fetchCallouts.rejected, state => {
      state.requestState = RequestStates.FAILED;
    });
  }
});
export default calloutsSlice.reducer;
export const selectCallouts = state => state.callouts.list;